module.exports = __webpack_public_path__ + "img/xinwen5.2cc57a2e.jpg";